var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6181 11.1311L7.477 26.5859C7.19112 27.6528 7.82428 28.7495 8.89121 29.0354L35.9371 36.2823C37.0041 36.5682 38.1007 35.935 38.3866 34.8681L42.5277 19.4133C42.8136 18.3463 42.1804 17.2497 41.1135 16.9638L14.0676 9.71686C13.0007 9.43097 11.904 10.0641 11.6181 11.1311Z",
    fill: "#0E773E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19V35C8 36.1046 8.89543 37 10 37H38C39.1046 37 40 36.1046 40 35V19C40 17.8954 39.1046 17 38 17H10C8.89543 17 8 17.8954 8 19Z",
    fill: "#24C56E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22C11.6569 22 13 20.6569 13 19H35C35 20.6569 36.3431 22 38 22V32C36.3431 32 35 33.3431 35 35H13C13 33.3431 11.6569 32 10 32V22Z",
    fill: "#90EFBB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 27,
    r: 4,
    fill: "#24C56E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardManage);
export default __webpack_public_path__ + "static/media/card-manage.9eef7d04132b31632a080f3a15837d27.svg";
export { ForwardRef as ReactComponent };